import React from 'react'
import { Box } from '@mui/material'
import { FlatTile } from '../tile';

import Carousel from 'components/carousel'

// import { ImageBlock } from '../../image-block';
// import { Actions } from '../../actions'
import { useAvatarStyles } from './generic.avatar.style'

// const getImage = item => item?.image
//   || item?.brands?.[0]?.image || item?.brand?.image
//   || item?.wrestler?.image || item?.wrestlers?.[0]?.image
//   || item?.championship?.image || item?.championships?.[0]?.image
//   || item?.appearances?.[0]?.wrestler?.image

export function GenericCarousel({
  // activeIndex = -1,
  // actions = [],
  collection = [],
  PresentationItem = false,
  actions = []
}) {
  const styles = useAvatarStyles()
  const clickHandler = (payload) => actions?.[0]?.onClick(payload)
  if (collection.length === 0) {
    return null
  }
  return (
    <Box className={styles.container}>
      <Carousel collection={collection} Tile={PresentationItem ? PresentationItem : FlatTile} onClick={clickHandler} />
    </Box>
  )
}
